var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar mini-width",style:({ background: _vm.background, height: _vm.height })},[_c('div',{staticClass:"nav-bar-box w-1400"},_vm._l((_vm.tarBarList),function(item,index){return _c('router-link',{key:index,class:[
        'router-link',
        'nav-item',
        index === _vm.activeIndex ? 'nav-item-active' : '',
      ],style:({ height: _vm.height }),attrs:{"to":item.path},on:{"click":function($event){_vm.activeIndex = index}}},[_vm._v(_vm._s(item.name)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }